var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgQueue = function SvgQueue(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#52525B",
    d: "M3.999 2a2.667 2.667 0 0 0 0 5.333h8a2.667 2.667 0 1 0 0-5.333h-8ZM1.999 9.333a.667.667 0 0 0 0 1.334h12a.667.667 0 0 0 0-1.334h-12ZM1.999 12.667a.667.667 0 1 0 0 1.333h12a.667.667 0 0 0 0-1.333h-12Z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgQueue);
export default ForwardRef;